jQuery(document).ready(function ($) {
        $(".tab-1").on("click", function () {
            $(".tab-click-1").addClass("active"), $(".tab-click-2").removeClass("active");
        }),
            $(".tab-2").on("click", function () {
                $(".tab-click-2").addClass("active"), $(".tab-click-1").removeClass("active");
            });
    
        $(".tab").on("click", function () {
            $(".tab").removeClass("reactive"), $(this).addClass("reactive");
        });
  
      /*  $(".faq-box").children(".exn-ans").hide();
       $(".faq-box h3").on("click", function () { alert('fdgfdg');
                $(this).next(".exn-ans").slideToggle("slow");
            }); */
       
          $(".faq-box").children(".exn-ans").hide();  // Hide all answers initially

    $(".faq-box h3").on("click", function() {
        var $currentAnswer = $(this).next(".exn-ans");

        // Slide up all other answers
        $(".faq-box .exn-ans").not($currentAnswer).slideUp("slow");

        // Toggle the clicked answer
        $currentAnswer.stop(true, true).slideToggle("slow");
    });

  
    });